<div class="wrapper">
  <div class="unbind">
    <app-action-dropdown-menu
      [actionsList]="['UNBIND_ADVERTISEMENT_PACKAGE']"
      (actionSelected)="unbindAdvertisementPackage()"
    />
  </div>
  <div class="header">
    Выбрана реклама с Id: {{ recordsAdvertisementPackagesParams().recordCalendarId }}
  </div>
  @if (recordsData) {
    <app-records-table-view
      class="records-table-view"
      [resourceParams]="advertisementPackagesResourceType"
      [tableColumnsParams]="recordTableParams"
      [tableData]="recordsData"
      [tableActions]="[]"
      [tableTotals]="recordsTotalData"
      [isNeedGroupsTable]="false"
    />
  }
  <div class="buttons-container">
    <button
      mat-button
      color="primary"
      (click)="onCloseDialog.emit('cancel')"
    >
      Закрыть
    </button>
  </div>
</div>
